__turbopack_context__.v({
  "bar": "WindowSkeleton-module__lZFcwa__bar",
  "root": "WindowSkeleton-module__lZFcwa__root",
});
